<bn-loading-overlay></bn-loading-overlay>

<h5>Taxa de juros equivalente</h5>

<a (click)="adicionarTaxaJurosEquivalente()" *ngIf="permissaoEdicao"><i class="fa fa-plus-circle cursor-pointer icone-adicionar"></i></a>

<bn-paginacao [total]="taxasJurosEquivalentes.length"
[tamanhoPagina]="pageSize" [numPagina]="page"
[opcoesTamanhoPagina]="opcoesPaginacao" (aoMudar)="mudancaPagina($event)">

    <div class="table-responsive">
        <table class="table table-hover">
            <thead>
            <tr>
                <th *ngIf="permissaoEdicao"></th>
                <th>Início de validade</th>
                <th>Indexador</th>
                <th>Taxa de juros equivalente (%)</th>
                <th *ngIf="permissaoEdicao"></th>
                <th *ngIf="permissaoEdicao"></th>
            <tr>
            </thead>
            <tbody>
            <tr *ngFor="let taxa of taxasExibidas; let i = index">
                <td *ngIf="permissaoEdicao">
                    <a (click)="removerTaxaJurosEquivalente(taxa)"><i class="fa fa-trash cursor-pointer"></i></a>
                </td>
                <td>
                    <bn-datepicker name="dataInicioValidade{{i}}" [(ngModel)]="taxa.dataInicioValidade" [disabled]="!taxa.modoEdicao"></bn-datepicker>
                </td>
                <td>
                    <select class="form-select" (change)="atribuiIndexador(taxa, $event.target.value)" [disabled]="!taxa.modoEdicao">
                        <option [value]="undefined" [selected]="!taxa.indexador"></option>
                        <option *ngFor="let indexador of indexadores" [value]="indexador.id" [selected]="indexador.id == taxa.indexador">{{indexador.nome}}</option>
                    </select>
                </td>
                <td>
                    <input type="text" class="form-control" name="taxaJurosEquivalente{{i}}" [(ngModel)]="taxa.taxaJurosEquivalente" [disabled]="!taxa.modoEdicao" bnMask="DECIMAL" [casasDecimais]="2">
                </td>
                <td *ngIf="permissaoEdicao">
                    <a (click)="editarTaxaJurosEquivalente(taxa)" *ngIf="!taxa.modoEdicao"><i class="fa fa-pencil cursor-pointer"></i></a>
                    <a (click)="salvarTaxaJurosEquivalente(taxa)" *ngIf="taxa.modoEdicao"><i class="fa fa-check cursor-pointer"></i></a>
                </td>
                <td *ngIf="permissaoEdicao">
                    <a (click)="cancelarEdicaoTaxaJurosEquivalente(taxa)" *ngIf="taxa.modoEdicao"><i class="fa fa-times cursor-pointer"></i></a>
                </td>
            </tr>
            </tbody>
        </table>
    </div>

</bn-paginacao>
